import api from './api';
import apiService from './api';

import { VaccinationInfo } from '../types/IVaccination';
import { IPaginationParams, IPaginationResponse } from 'src/models/interfaces/pagination';

const baseUrl = '/user-vaccination';

interface UserVaccinationModel {
  ids: number[];
  status?: 'attended' | 'rejected';
}

class VaccinationService {
  public async getAll(params: IPaginationParams): Promise<IPaginationResponse<VaccinationInfo>> {
    return api.get(`${baseUrl}`, { params });
  }

  public accept = async (data: UserVaccinationModel) => api.post(`${baseUrl}`, { ...data, status: 'attended' });

  public cancel = async (data: UserVaccinationModel) => api.post(`${baseUrl}`, { ...data, status: 'rejected' });

  public exportReport(params: IPaginationParams) {
    return apiService.get(`${baseUrl}/report/download`, {
      responseType: 'blob',
      headers: { 'Accept': 'application/vnd.ms-excel' },
      params: { ...params, noPaginate: true }
    });
  }
}

export default new VaccinationService();
